import { developmentConfig } from './configs/development.esm.js';
import { dogfoodConfig } from './configs/dogfood.esm.js';
import { canaryConfig } from './configs/canary.esm.js';
import { productionConfig } from './configs/production.esm.js';

var configs = {
    development: developmentConfig,
    dogfood: dogfoodConfig,
    canary: canaryConfig,
    production: productionConfig
};
var config;
function init(env) {
    config = configs[env];
}
function getConfig() {
    if (!config) {
        throw new Error('Environment not initialized. Call init() first.');
    }
    return config;
}

export { getConfig, init };
